import { render, staticRenderFns } from "./allList.vue?vue&type=template&id=b231379a"
import script from "./allList.vue?vue&type=script&lang=js"
export * from "./allList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b231379a')) {
      api.createRecord('b231379a', component.options)
    } else {
      api.reload('b231379a', component.options)
    }
    module.hot.accept("./allList.vue?vue&type=template&id=b231379a", function () {
      api.rerender('b231379a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examine/customerReviewManage/allList.vue"
export default component.exports